import {Routes,Route} from 'react-router-dom';
import { memo } from 'react';
import {default as NotRegisteredReport} from './NotRegisteredReport';
import {default as DueInductionReport} from './DueInductionReport';
// import {default as AllStudentReport} from './RegisterStudent';
import {default as TranscriptReport} from './TranscriptReport';
import {default as AppliedInduction} from './AppliedInduction';
import {default as StudentScoreReport} from './StudentScoreReport';
import {default as MovedToMembershipReport} from './MovedToMembershipReport';
import {default as StudentApplicationReport} from './StudentApplicationReport';
import {default as RegistrationReport} from './RegistrationReport';
import {default as ScoreReport} from './ScoreReport';
import {default as PerformanceReport} from './PerformanceReport';
import AllStudentReport from './AllStudentReport';
import OutstandingDuesReport from './OutstandingDuesReport';





export const DefaultReport = () =>{
  return <div>
    Report
  </div>
}


const Report = () => {
  return (
    <Routes>
      <Route path="/" element={<RegistrationReport />}/>
      <Route path="/all-student-report" element={<AllStudentReport />} />
      <Route path="/out-standing-dues-report" element={<OutstandingDuesReport />} />
      <Route path="/registration-report" element={<RegistrationReport />} />
      <Route path="/performance-report" element={<PerformanceReport />} />
      <Route path="/score-report" element={<ScoreReport />} />
      <Route path="/due-induction-report" element={<DueInductionReport />} />
       <Route path="/transcript-report" element={<TranscriptReport />} /> 
      <Route path="/not-registered-report" element={<NotRegisteredReport />} />
      <Route path="/applied-induction" element={<AppliedInduction />} />
      <Route path="/student-score-report" element={<StudentScoreReport />} />
      <Route path="moved-to-membership-report" element={<MovedToMembershipReport/>}/>
      <Route path="student-application-report" element={<StudentApplicationReport/>}/>

    </Routes>
  )
}

export default memo(Report);